import type { ContactOrderPlanningSubmissionResult } from "../../../_logic/contact-orders-contract"

type CommittedSubmissionResult<TCommitReceipt> = Extract<
  ContactOrderPlanningSubmissionResult<TCommitReceipt>,
  { kind: "committed" }
>

export const runContactOrderPlanningSubmissionTransition = async <TCommitReceipt>({
  result,
  onRowsRemoved,
  onCommitted,
  onSubmissionResult,
}: {
  result: ContactOrderPlanningSubmissionResult<TCommitReceipt>
  onRowsRemoved?: (eventIds: string[]) => void | Promise<void>
  onCommitted: (result: CommittedSubmissionResult<TCommitReceipt>) => void | Promise<void>
  onSubmissionResult: (
    result: ContactOrderPlanningSubmissionResult<TCommitReceipt>,
  ) => void | Promise<void>
}) => {
  const removedEventIds =
    result.kind === "removed" || result.kind === "committed" ? result.removedEventIds : []

  if (removedEventIds.length) await onRowsRemoved?.([...removedEventIds])

  if (result.kind === "committed") await onCommitted(result)

  await onSubmissionResult(result)
}
